import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import { AuthProvider } from './hooks/AuthProvider'
import { AdminViewProvider } from './contexts/AdminViewContext'
import { TokenProvider } from './hooks/TokenProvider'
import { router } from './router'

import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <AdminViewProvider>
        <TokenProvider>
          <RouterProvider router={router} />
        </TokenProvider>
      </AdminViewProvider>
    </AuthProvider>
  </StrictMode>
)
